import React from "react";
import { BackgroundImage, TeethLogo, ServiceBottomButton } from "../../Components"
import aestheticImg from "../../assets/Images/aesthetics-dentistry-home.jpg"

const AestheticsDentistry = (props) => {
    const { selectedLanguage } = props
    return (
        <div className="main">
            <BackgroundImage heading={selectedLanguage?.txt_aesthetics_dentistry} text={selectedLanguage?.txt_explore_our_services} mainClass='aesthetics-background' />
            <TeethLogo heading={selectedLanguage?.txt_aesthetics_dentistry} />
            <div className="dental-service-main">
                <div className="dental-service-img-div">
                    <img src={aestheticImg} alt="dentalImg" />
                </div>
                <div className="dental-service-text-div">
                    <p>{selectedLanguage?.asthetic_paragraph_one}</p>
                    <p>{selectedLanguage?.asthetic_paragraoh_two}</p>
                    <h2>{selectedLanguage?.benifits_of_laser_heading}</h2>
                    <ul>
                        <li>{selectedLanguage?.txt_corrects_brown_yello_and_mottled_totth_staining}</li>
                        <li>{selectedLanguage?.txt_works_on_people_of_all_ages}</li>
                        <li>{selectedLanguage?.txt_improves_a_dull_smile_restoring_brightness_andBringing}</li>
                        <li>{selectedLanguage?.txt_fast_and_gentle_whitnening_system}</li>
                        <li>{selectedLanguage?.txt_more_efficient_laser_energy_allows}</li>
                        <li>{selectedLanguage?.txt_no_need_to_wear_the_tray_over_night}
                        </li>
                        <li>{selectedLanguage?.txt_accredited_by_FDA_and_CE}</li>
                    </ul>
                </div>
            </div>
            <ServiceBottomButton {...props} />
        </div>
    )
}

export default AestheticsDentistry